import { EQM1010_R01Dto } from "./Dto_EQM1010_R01";
import { useEQM1010_R01Store } from "./Store_EQM1010_R01";

const EQM1010_R01_DISPLAY_REF01_LIST = ['1', '2', '3'];

const getEQM1010_R01ItemNameByRef01 = (ref01: string): string => {
    const nameMap: Record<string, string> = {
        '1': '설비상태',
        '2': '생산실적',
        '3': '비상정지',
    };
    return nameMap[ref01] || '알 수 없음';
};

const getEQM1010_R01LatestTime = (dtoList: EQM1010_R01Dto[]): string => {
    let latestDateTime: Date | null = null;

    for (const item of dtoList) {
        if (!item.createdatetime) continue;

        const dateTime = item.createdatetime instanceof Date
            ? item.createdatetime
            : new Date(item.createdatetime as unknown as string);
        if (Number.isNaN(dateTime.getTime())) continue;

        if (!latestDateTime || dateTime > latestDateTime) {
            latestDateTime = dateTime;
        }
    }

    if (!latestDateTime) return '-';

    const hours = String(latestDateTime.getHours()).padStart(2, '0');
    const minutes = String(latestDateTime.getMinutes()).padStart(2, '0');
    return `${hours}:${minutes}`;
};

export const Info_EQM1010_R01 = () => {
    const { latestDataList } = useEQM1010_R01Store();
    const infoList = latestDataList ?? [];

    const getEQM1010_R01ItemByRef01 = (ref01: string): EQM1010_R01Dto | undefined => {
        return infoList.find((item) => item.ref01 === ref01);
    };

    return (
        <div className="flex gap-32 items-center justify-center bg-white border border-gray-300 pb-1 px-4 mx-3">
            <div className="flex flex-col items-start">
                <p className="text-2xl text-gray-600 font-bold">최종시간</p>
                <p className="text-xl">
                    <span className="inline-flex items-center px-5 justify-center bg-white text-gray-600">
                        {getEQM1010_R01LatestTime(infoList)}
                    </span>
                </p>
            </div>

            {EQM1010_R01_DISPLAY_REF01_LIST.map((ref01) => {
                const item = getEQM1010_R01ItemByRef01(ref01);
                return (
                    <div key={ref01} className="flex flex-col items-center">
                        <p className="text-2xl text-gray-600 font-bold">
                            {getEQM1010_R01ItemNameByRef01(ref01)}
                        </p>
                        <p className="text-xl">
                            <span className="inline-flex items-center justify-center px-2 w-[80px] h-[32px] bg-white text-black border-[1px] border-gray-300">
                                <span className="text-black-500">
                                    {item?.valueDisplay || '-'}
                                </span>
                            </span>
                        </p>
                    </div>
                );
            })}
        </div>
    );
};
